var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title != ""
    ? _c(
        "h3",
        {
          on: {
            click: function($event) {
              return _vm.$router.back()
            }
          }
        },
        [
          _vm.type == ""
            ? _c("i", { staticClass: "el-icon-arrow-left" })
            : _vm._e(),
          _vm._v(_vm._s(_vm.title))
        ]
      )
    : _c("h3", {}, [_vm._v("欢迎回来～")])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ce36d65", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce36d65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubTitleComponent.vue
// module id = null
// module chunks = 